(function () {

  if (window.marstelaWishlistControllerV3) {
    return;
  }

  window.marstelaWishlistControllerV3 = true;

  var API_BASE =
    'https://wishlist.sqa-api.com/bundle/api/v2/sf/ws';

  var HEART_OUTLINE =
    'm244 84 11.1 12 12-11.98C300.6 51.37 347 36.51 392.6 44.1c68.9 11.48 119.4 71.1 119.4 141v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.59 300.4C17.23 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.52-129.52 119.4-141 44.7-7.59 92 7.27 124.6 39.9-.9 0 0 .01 0 0zm11.1 79.9-45-46.8c-21.7-20.82-52.5-30.7-82.8-25.66C81.55 99.07 48 138.7 48 185.1v5.8c0 28.2 11.71 55.2 32.34 74.4L256 429.3l175.7-164c20.6-19.2 32.3-46.2 32.3-74.4v-5.8c0-46.4-33.6-86.03-79.3-93.66-30.3-5.04-61.1 4.84-82.8 25.66l-46.8 46.8z';

  var HEART_SOLID =
    'M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l180.7-168.7c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-125.6 39.9L256 96l-12-12c-32.6-32.6-79.9-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z';

  var wishlistItems = {};
  var vitalsSid = '';
  var vitalsCid = '';
  var wishlistReady = false;


  function findVitalsConfig() {

    var resources =
      performance.getEntriesByType('resource');

    var i;

    for (i = 0; i < resources.length; i++) {

      var url = resources[i].name || '';

      if (
        url.indexOf(API_BASE + '?') !== 0
      ) {
        continue;
      }

      try {

        var parsed =
          new URL(url);

        var sid =
          parsed.searchParams.get('sid');

        var cid =
          parsed.searchParams.get('cid');

        if (sid && cid) {

          vitalsSid = sid;
          vitalsCid = cid;

          return true;
        }

      } catch (error) {}

    }

    return false;
  }


  function getSelectedState(card) {

    if (!card) {
      return null;
    }

    var productId =
      card.getAttribute(
        'data-marstela-selected-product-id'
      );

    var variantId =
      card.getAttribute(
        'data-marstela-selected-variant-id'
      );

    if (!productId || !variantId) {
      return null;
    }

    return {
      productId: String(productId),
      variantId: String(variantId)
    };
  }


  function loadWishlist() {

    if (!vitalsSid || !vitalsCid) {
      return;
    }

    var url =
      API_BASE +
      '?sid=' +
      encodeURIComponent(vitalsSid) +
      '&cid=' +
      encodeURIComponent(vitalsCid);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      cache: 'no-store'
    })
    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          'Errore lettura wishlist: ' +
          response.status
        );
      }

      return response.json();
    })
    .then(function (data) {

      wishlistItems = {};

      if (Array.isArray(data)) {

        data.forEach(function (item) {

          if (
            !item ||
            !item.product ||
            !item.product.id
          ) {
            return;
          }

          wishlistItems[
            String(item.product.id)
          ] = {
            wishlistId: item.id,
            variantId:
              item.variant && item.variant.id
                ? String(item.variant.id)
                : ''
          };

        });
      }

      wishlistReady = true;

      renderAllHearts();

    })
    .catch(function (error) {

      console.warn(
        '[MARSTELA Wishlist]',
        error
      );

    });
  }


  function renderHeart(card) {

    if (!wishlistReady || !card) {
      return;
    }

    var state =
      getSelectedState(card);

    if (!state) {
      return;
    }

    var heart =
      card.querySelector(
        '.Vtl-WishlistButton__WishlistIconButton'
      );

    if (!heart) {
      return;
    }

    if (
      heart.getAttribute(
        'data-marstela-busy'
      ) === 'true'
    ) {
      return;
    }

    var svg =
      heart.querySelector('svg');

    var path =
      heart.querySelector('svg path');

    if (!svg || !path) {
      return;
    }

    var inWishlist =
      Boolean(
        wishlistItems[state.productId]
      );

    heart.setAttribute(
      'data-product-id',
      state.productId
    );

    heart.setAttribute(
      'data-variant-id',
      state.variantId
    );

    if (inWishlist) {

      heart.setAttribute(
        'title',
        'Rimuovi dalla Wishlist'
      );

      path.setAttribute(
        'd',
        HEART_SOLID
      );

    } else {

      heart.setAttribute(
        'title',
        'Aggiungi alla Wishlist'
      );

      path.setAttribute(
        'd',
        HEART_OUTLINE
      );

    }

    svg.style.removeProperty('fill');
  }


  function renderAllHearts() {

    var rows =
      document.querySelectorAll(
        '.marstela-card-colors'
      );

    rows.forEach(function (row) {

      var card =
        row.closest('product-card');

      if (card) {
        renderHeart(card);
      }

    });
  }


  function restoreHeart(heart) {

    if (!heart) {
      return;
    }

    heart.innerHTML =
      '<div class="Vtl-WishlistButton__IconWrapper">' +
        '<svg xmlns="http://www.w3.org/2000/svg" ' +
        'viewBox="0 0 512 512" ' +
        'style="min-width:20px;min-height:20px;width:20px;height:20px;">' +
          '<path d="' +
            HEART_OUTLINE +
          '"></path>' +
        '</svg>' +
      '</div>';
  }


  function showLoading(heart) {

    if (!heart) {
      return;
    }

    heart.setAttribute(
      'data-marstela-busy',
      'true'
    );

    heart.innerHTML =
      '<div title="Loading..." class="Vtl-Spinner"></div>';
  }


  function addWishlistItem(
    state,
    card,
    heart
  ) {

    var payload = {
      shop_id: Number(vitalsSid),
      customerId: String(vitalsCid),
      productId: Number(state.productId),
      variantId: Number(state.variantId)
    };

    fetch(API_BASE, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type':
          'text/plain; charset=UTF-8'
      },
      body: JSON.stringify(payload)
    })
    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          'Errore aggiunta wishlist: ' +
          response.status
        );
      }

      return response.json();
    })
    .then(function (item) {

      wishlistItems[state.productId] = {
        wishlistId: item.id,
        variantId: state.variantId
      };

      heart.setAttribute(
        'data-marstela-busy',
        'false'
      );

      restoreHeart(heart);
      renderHeart(card);

    })
    .catch(function (error) {

      heart.setAttribute(
        'data-marstela-busy',
        'false'
      );

      console.error(
        '[MARSTELA Wishlist]',
        error
      );

      restoreHeart(heart);
      loadWishlist();

    });
  }


  function removeWishlistItem(
    state,
    card,
    heart
  ) {

    var item =
      wishlistItems[state.productId];

    if (!item || !item.wishlistId) {

      heart.setAttribute(
        'data-marstela-busy',
        'false'
      );

      restoreHeart(heart);
      loadWishlist();

      return;
    }

    var url =
      API_BASE +
      '/' +
      item.wishlistId;

    fetch(url, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          'Errore rimozione wishlist: ' +
          response.status
        );
      }

      delete wishlistItems[
        state.productId
      ];

      heart.setAttribute(
        'data-marstela-busy',
        'false'
      );

      restoreHeart(heart);
      renderHeart(card);

    })
    .catch(function (error) {

      heart.setAttribute(
        'data-marstela-busy',
        'false'
      );

      console.error(
        '[MARSTELA Wishlist]',
        error
      );

      restoreHeart(heart);
      loadWishlist();

    });
  }


  window.addEventListener(
    'click',
    function (event) {

      var target =
        event.target;

      if (!(target instanceof Element)) {
        return;
      }

      var heart =
        target.closest(
          '.Vtl-WishlistButton__WishlistIconButton'
        );

      if (!heart) {
        return;
      }

      var card =
        heart.closest(
          'product-card'
        );

      if (
        !card ||
        !card.querySelector(
          '.marstela-card-colors'
        )
      ) {
        return;
      }

      if (!wishlistReady) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (
        heart.getAttribute(
          'data-marstela-busy'
        ) === 'true'
      ) {
        return;
      }

      var state =
        getSelectedState(card);

      if (!state) {
        return;
      }

      var exists =
        Boolean(
          wishlistItems[state.productId]
        );

      showLoading(heart);

      if (exists) {

        removeWishlistItem(
          state,
          card,
          heart
        );

      } else {

        addWishlistItem(
          state,
          card,
          heart
        );

      }

    },
    true
  );


  document.addEventListener(
    'marstela:product-change',
    function (event) {

      var card =
        event.target;

      if (!(card instanceof Element)) {
        return;
      }

      setTimeout(function () {

        renderHeart(card);

      }, 30);

    }
  );


  var initAttempts = 0;

  var initTimer =
    setInterval(function () {

      initAttempts++;

      if (findVitalsConfig()) {

        clearInterval(initTimer);
        loadWishlist();

        return;
      }

      if (initAttempts >= 40) {

        clearInterval(initTimer);

        console.warn(
          '[MARSTELA Wishlist]',
          'Configurazione Vitals non trovata'
        );
      }

    }, 250);

})();